import React, { useState,useContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { IoCloudDownloadOutline } from "react-icons/io5";
import { imgs } from './imgs';
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { MdAddShoppingCart } from "react-icons/md";
import { CartContext } from '../CartContext';


const stripePromise = await loadStripe("pk_test_51NsOwWH5L6zjUGt73ypZZOrPzKTPImvMPeT3akixYWai55nu8lX6nbgalKnmNi1zt54VH3aSKQ80KwcfgrPwTEfK00iCRAUnsS");

const ITEMS_PER_PAGE = 51;

const ImageTable = () => {
  const [hoveredImage, setHoveredImage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(imgs.length / ITEMS_PER_PAGE);
  const cart = useContext(CartContext);
  const handleMouseEnter = (id) => setHoveredImage(id);
  const handleMouseLeave = () => setHoveredImage(null);

  const handleDownload = async (imageSrc) => {
    try {
      const stripe = await stripePromise;
      const response = await fetch('https://api-shipping-28612190fdf4.herokuapp.com/strpforimg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ imageSrc }),
      });
      if (!response.ok) throw new Error('Failed to create checkout session');
      const session = await response.json();
      const result = await stripe.redirectToCheckout({ sessionId: session.id });
      if (result.error) console.error('Stripe Checkout error:', result.error);
    } catch (error) {
      console.error('Checkout process failed:', error);
    }
  };

  const handlePageChange = (newPage) => setCurrentPage(newPage);

  const startIdx = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIdx = startIdx + ITEMS_PER_PAGE;
  const currentImgs = imgs.slice(startIdx, endIdx);

  function add(img) {
    const p=Number(img.alt).toFixed(2)
    console.log(p)
    alert(`Image Info:\nID: W&W${((img.id * img.id - 9989000000) / 100000).toFixed(0)}\nPrice: $${img.alt}\nURL: ${img.src}`);
  cart.addOneToCart(img.id, p, "","", "", img.src, "", "", "", "")

  }
  
  // cart.addOneToCart(product.id, p, product.size, props.color, product.name, imgurl, props.thumImage, props.thumId, product.image2, props.rating)

  return (
    <div style={styles.container}>
      <div style={styles.gridContainer}>
        {currentImgs.map((img) => (
          <div 
            key={img.id} 
            style={styles.imageCard} 
            onMouseEnter={() => handleMouseEnter(img.id)} 
            onMouseLeave={handleMouseLeave}
          >
            <div style={styles.imageWrapper}>
              <img src={img.src} alt={img.alt} style={styles.image} />
              
              {hoveredImage === img.id && (
                <button onClick={() => handleDownload(img.src)} style={styles.downloadButton}>
                  <IoCloudDownloadOutline />
                </button>
              )}

{/* <MdAddShoppingCart style={styles.cartButton} onClick={() => add(img)} /> */}

            </div>

            <div style={styles.imageText}>ID: W&W{((img.id * img.id - 9989000000) / 100000).toFixed(0)}</div>
            <div style={styles.imageText}>Price: ${img.alt}</div>
          </div>
        ))}
      </div>

      <div style={styles.pagination}>
        <button 
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={styles.pageButton}
        >
          <FaArrowLeft />
        </button>
        <span style={{    marginBottom:"20px"}}>Page {currentPage} of {totalPages}</span>
        <button 
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={styles.pageButton}
        >
          <FaArrowRight />
        </button>
      </div>
    </div>
  );
};

/** Responsive & Uniform Card Styles */
const styles = {
  container: {
    width: '90%',
    maxWidth: '1200px',
    margin: 'auto',
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: '15px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageCard: {
    width: '190px',  // Uniform width
    height: '250px', // Uniform height
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '10px',
    border: '1px solid black',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
  },
  imageWrapper: {
    width: '100%',
    height: '180px',  // Fixed height for images
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',  // Ensures images fit the same size without stretching
    borderRadius: '5px',
  },
  downloadButton: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: "red",
    fontSize: '20px',
  },
  cartButton: {
    position: 'absolute',
    bottom: '5px',
    right: '5px',
    fontSize: '20px',
    color: 'green',
    cursor: 'pointer',
  },
  imageText: {
    fontSize: '14px',
    textAlign: 'center',
  },
  pagination: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
 
  },
  pageButton: {
    padding: '5px 15px',
    cursor: 'pointer',
    border: 'none',
    backgroundColor: '#333',
    color: '#fff',
    borderRadius: '5px',
    transition: 'background 0.3s ease',
    marginBottom:"20px"
  },
};

export default ImageTable;
